<template>
  <Modal
    id="invite-members"
    title="Select members to invite"
    :buttonName="buttonTitle"
    :disabled="isDisabled"
    @button="sendInvitations"
    @resetModalWhenClose="resetChosenUsers"
    ref="modal"
    data-cy="modalInviteToJoin"
  >
    <NewGroupMembers
      ref="member"
      v-if="!sendingInvites && responses.length <= 0"
      @userWasChosen="enableSendInvitationButton"
    />
    <div
      class="spinner-border m-2"
      role="status"
      v-if="sendingInvites && responses.length <= 0"
    >
      <span class="sr-only">Loading...</span>
    </div>
    <div class="user-container" v-if="responses.length > 0">
      <div v-for="response in responses" :key="response.userId">
        <div class="my-2 pl-3 container">
          <div class="row">
            <div class="col mr-1 row-bg p-2 rounded">
              <div
                class="birthday-author-name float-left ml-2"
                data-cy="invitationResponse"
              >
                <a class="author-name font-weight-bold text-break">{{
                  response.username + ": " + response.text
                }}</a>
              </div>
              <svg
                class="check-icon float-right mb-1"
                v-if="response.invitationSent"
              >
                <use
                  xlink:href="/svg-icons/sprites/icons.svg#olymp-check-icon"
                />
              </svg>
              <svg
                class="warn-icon float-right mb-1"
                v-if="!response.invitationSent"
              >
                <use
                  xlink:href="/svg-icons/sprites/icons.svg#olymp-little-delete"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/atoms/Modal";
import NewGroupMembers from "@/components/molecules/NewGroupMembers";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import { mapGetters } from "vuex";
export default {
  name: "ModalInviteNewMember",
  mixins: [GroupHelperVue, UserHelperVue],
  components: {
    Modal,
    NewGroupMembers,
  },
  data() {
    return {
      sendingInvites: false,
      buttonTitle: "Send Invitations",
      isDisabled: true
    };
  },
  computed: {
    ...mapGetters({
      moderatorId: "getModeratorID",
    }),
    isModerator() {
      return this.moderatorId === this.loggedUser.id;
  },
    responses() {
      return this.inviteMembersResponse.map((item) => {
        let text = "";
        let invitationSent = null;
        if (item.result.includes("already a member")) {
          text = "This user has already been invited to this group";
          invitationSent = false;
        } else if (item.result.includes("Everything ok!")) {
          text = "Invitation sent!";
          invitationSent = true;
        }
        return {
          ...item,
          text,
          invitationSent,
        };
      });
    },
  },
  methods: {
    async sendInvitations() {
      if (this.buttonTitle === "Send Invitations") {
        this.$refs.member?.storeMembers();
        try {
          this.sendingInvites = true;
          await this.getNewGroupMembers.forEach((element) => {
            this.inviteMember({
              groupId: this.getCurrentGroup.id,
              userId: element.id,
              username: element.username,
              hasInvitedByModerator: this.isModerator,
            });
            if (this.isModerator) {
              this.postUserGroupMessage({
                partner: element.id,
                group: this.getCurrentGroup.id,
                postMsg:
                  "Hi, I've invited you to join the group " +
                  this.getCurrentGroup.name,
                newChat: true,
              });
            }
          });
          this.sendingInvites = false;
          this.buttonTitle = "Ok";
        } catch (error) {
          this.buttonTitle = "Ok";
        }
      } else if (this.buttonTitle === "Ok") {
        this.resetModal();
      }
    },
    resetModal() {
      this.emptyInviteResponses();
      this.resetNewGroup();
      this.$refs.modal.closeModal();
      this.buttonTitle = "Send Invitations";
    },
    resetChosenUsers(){
      this.emptyInviteResponses();
      this.resetNewGroup();
      this.$refs.member?.resetChosenUsersAndQuery()
      this.inviteMembersResponse = []
      this.buttonTitle = "Send Invitations";
      this.isDisabled = true
    },
    enableSendInvitationButton() {
      this.isDisabled = false
    }
  },
};
</script>

<style scoped>
.header-img {
  height: 34px;
  width: 34px;
}
.check-icon {
  height: 17px;
  width: 17px;
  fill: rgb(81, 182, 95);
}
.warn-icon {
  height: 17px;
  width: 17px;
  fill: rgb(241, 91, 4);
}
.row-bg {
  background-color: whitesmoke;
}
.user-container {
  max-height: 200px;
  overflow-y: auto;
}
.autocomplete-positioning {
  position: absolute;
  z-index: 10010;
  left: 0;
  width: 100%;
}
</style>
